export const COUNTDOWN_TIMER_WIDGET_TYPE = 'countdown_timer';
export const DEFAULT_COUNTDOWN_SECONDS = 3;
export const MIN_COUNTDOWN_SECONDS = 1;
export const MAX_COUNTDOWN_SECONDS = 599;

export function clampCountdownSeconds(seconds: number): number {
  if (!Number.isFinite(seconds)) return DEFAULT_COUNTDOWN_SECONDS;
  return Math.min(MAX_COUNTDOWN_SECONDS, Math.max(MIN_COUNTDOWN_SECONDS, Math.round(seconds)));
}

/** Whole seconds left on the countdown; holds the configured value through the first elapsed second. */
export function countdownRemainingSeconds(configuredSeconds: number, programElapsedSeconds: number): number {
  const configured = clampCountdownSeconds(configuredSeconds);
  const elapsed = Number.isFinite(programElapsedSeconds) ? Math.max(0, programElapsedSeconds) : 0;
  return Math.max(0, Math.ceil(configured - elapsed));
}
